import { HelpFactoryComponent, SortableList } from '@/components/common';
import { HelpFeature } from '@/model/HelpModel';
import { UpOutlined } from '@ant-design/icons';
import { Collapse, Space } from 'antd';
import React, { useState } from 'react';
import { QueuedDownloadTable } from '../QueuedDownloadTable/QueuedDownloadTable';
import './queuedDownload.scss';

const { Panel } = Collapse;

// Normal properties for the component
interface OwnProps {}

// combine them together
type Props = OwnProps;

const topicId: string = 'QueuedDownloads';

const QueuedDownload: React.FC = (props: Props) => {
	//#region State Management Variables
	const [isExpanded, setIsExpanded] = useState<boolean>(true);
	//#endregion

	return (
		<div className='queued-download-container'>
			<Collapse
				bordered={true}
				defaultActiveKey={'1'}
				expandIconPosition='end'
				expandIcon={({ isActive }) => (
					<Space size={14}>
						<span
							onClick={e => {
								e.stopPropagation();
								e.preventDefault();
							}}>
							<HelpFactoryComponent helpFeature={HelpFeature.StatusDashboard} topicId={topicId} size='medium' />
						</span>
						<UpOutlined rotate={isActive ? 180 : 0} />
					</Space>
				)}
				onChange={(keys: string[]) => {
					setIsExpanded(keys.length === 1);
				}}
				className={'status-widget-collapse'}>
				<Panel
					id='statusDashboardQueuedDownloadWidget'
					key='1'
					header={<SortableList.DragHandle className='status-dashboard-widget-panel-header-title'>{_('QueuedDownloads')}</SortableList.DragHandle>}
					className='status-widget status-widget-collapse-content'>
					<QueuedDownloadTable isExpanded={isExpanded} />
				</Panel>
			</Collapse>
		</div>
	);
};

export { QueuedDownload };
